<form [formGroup]="form" (ngSubmit)="save()" class="flex flex-col h-full">
	<div class="pt-3 pb-6 px-6 grow overflow-auto">
		<div class="grid grid-cols-2 gap-4">
			<app-date-picker
				label="Agreement date"
				[maxDate]="closingDate.value"
				[formControl]="agreementDate"
				maxDateErrorLabel="Closing Date"
				[testHook]="testHooks.AgreementDateDatePicker"
			></app-date-picker>
			<app-date-picker
				*ngIf="isNotRefinance"
				label="Requisition date"
				[maxDate]="closingDate.value"
				[formControl]="requisitionDate"
				maxDateErrorLabel="Closing Date"
				[testHook]="testHooks.RequisitionDateDatePicker"
			></app-date-picker>
			<app-date-picker
				*ngIf="showOccupancyDate"
				[maxDate]="closingDate.value"
				label="Occupancy date"
				[formControl]="occupancyDate"
				maxDateErrorLabel="Closing Date"
				[testHook]="testHooks.OccupancyDateDatePicker"
			></app-date-picker>
			<app-date-picker
				label="Closing date"
				[minDate]="minDate"
				[formControl]="closingDate"
				[minDateErrorLabel]="minDateLabel"
				[testHook]="testHooks.ClosingDateDatePicker"
			></app-date-picker>
		</div>
		<div class="grid grid-cols-2 gap-4 mt-5">
			<h4 class="col-span-full text-lg m-0">Book An Appointment</h4>
			<app-date-picker
				[submitted]="submitted"
				label="Appointment date"
				[maxDate]="closingDate.value"
				maxDateErrorLabel="Closing Date"
				[formControl]="appointmentDate"
				[minDateErrorLabel]="minDateLabel"
				[testHook]="testHooks.AppointmentDateDatePicker"
			></app-date-picker>
			<div class="flex items-end">
				<atomic-time-picker
					[formControl]="appointmentTime"
				></atomic-time-picker>
			</div>
		</div>
		<div class="flex flex-col mt-6 gap-4">
			<h4 class="col-span-full text-lg m-0">Signing Location</h4>
			<div class="grid grid-cols-2 gap-4 items-end">
				<app-select
					label="Executing Location"
					[formControl]="officeSigningLocationType"
					[submitted]="submitted"
					placeholder="Select location type"
					[testHook]="testHooks.ExecutingLocationSelect"
				>
					@for (
						locationType of locationTypeDropdownOptions;
						track locationType.id
					) {
						<option
							[value]="locationType.id"
							[testHook]="testHooks.LocationTypeOption"
						>
							{{ locationType.label }}
						</option>
					}
				</app-select>
				<app-input
					label="Location Specified"
					[formControl]="officeSigningLocation"
					[testHook]="testHooks.LocationSpecified"
				></app-input>
				<app-select
					label="Executing Region"
					[formControl]="officeSigningRegionType"
					[submitted]="submitted"
					placeholder="Select region type"
					[testHook]="testHooks.ExecutingRegionSelect"
				>
					@for (regionType of regionTypeDropdownOptions; track regionType.id) {
						<option
							[value]="regionType.id"
							[testHook]="testHooks.SigningRegionTypeOption"
						>
							{{ regionType.label }}
						</option>
					}
				</app-select>
				<app-input
					label="Region Specified"
					[formControl]="officeSigningRegion"
					[testHook]="testHooks.RegionSpecified"
				></app-input>
			</div>
			<div>
				<ui-checkbox
					label="Client is signing remotely"
					[formControl]="remoteSigning"
				/>
			</div>
			@if (remoteSigning.value) {
				<div class="grid grid-cols-2 gap-4 items-end">
					<app-input
						label="Client Executing Location"
						[formControl]="clientSigningLocationType"
						[submitted]="submitted"
						[testHook]="testHooks.ClientExecutingLocation"
					></app-input>
					<app-input
						label="Client Executing Location Specified"
						[formControl]="clientSigningLocation"
						[testHook]="testHooks.ClientExecutingLocationSpecified"
					></app-input>
					<app-input
						label="Client Executing Region"
						[formControl]="clientSigningRegionType"
						[submitted]="submitted"
						[testHook]="testHooks.ClientExecutingRegion"
					></app-input>
					<app-input
						label="Client Executing Region Specified"
						[formControl]="clientSigningRegion"
						[testHook]="testHooks.ClientExecutingRegionSpecified"
					></app-input>
				</div>
			}
			@if (
				(showOfficeSignatureLocationPreview$ | async) ||
				(showClientSignatureLocationPreview$ | async)
			) {
				<div class="rounded-md bg-gray-50 p-4 mt-3">
					<div class="font-semibold text-base">
						Signing Location Preview Text
					</div>
					<div class="grid grid-cols-[1fr,6fr] gap-5 mt-3">
						<span class="text-sm font-semibold">Witness</span>
						@if (showOfficeSignatureLocationPreview$ | async) {
							<span class="text-sm text-gray-500">
								{{ officeSigningLocationType.value }} of
								{{ officeSigningLocation.value }},
								{{ officeSigningRegionType.value }} of
								{{ officeSigningRegion.value }}
							</span>
						}
					</div>
					@if (showClientSignatureLocationPreview$ | async) {
						<div class="grid grid-cols-[1fr,6fr] gap-5 mt-3">
							<span class="text-sm font-semibold">Client</span>
							<span class="text-sm text-gray-500">
								{{ clientSigningLocationType.value }} of
								{{ clientSigningLocation.value }},
								{{ clientSigningRegionType.value }} of
								{{ clientSigningRegion.value }}
							</span>
						</div>
					}
				</div>
			}
		</div>
		<div class="flex flex-1 flex-col gap-4 mt-6">
			<h4 class="text-lg m-0">Commissioner</h4>
			<ui-button-segmented
				[options]="commissionerRadioGroupItems"
				[selectedId]="commissionerSelectionType.value"
				(selectedIdChange)="setOfficialsSelectionType('commissioner', $event)"
				[fullWidth]="true"
				variant="text-only"
				intercomAttr="commissionerTypeOptions"
				[testHook]="testHooks.ButtonSegmented"
			></ui-button-segmented>
			<div
				*ngIf="
					commissionerSelectionType.value === COMMISSIONER_SELECTION_TYPE.OTHER
				"
			>
				<app-business-user-dropdown
					label="Other Lawyer/Clerk"
					[userId]="commissionerUserId?.value"
					(selected)="setCommissionerUser($event)"
				></app-business-user-dropdown>

				<div class="flex gap-4 items-center my-6">
					<span class="flex flex-1 border-t border-grey-light"></span>
					<span class="text-sm text-grey-light"
						>Or Set Custom Commissioner</span
					>
					<span class="flex flex-1 border-t border-grey-light"></span>
				</div>

				<div class="flex flex-col gap-4">
					<app-input
						label="Name"
						[formControl]="commissionerName"
						(debounce)="customCommissionerChanged()"
						[testHook]="testHooks.CommissionerName"
					></app-input>
					<app-input
						label="Email"
						[formControl]="commissionerEmail"
						(debounce)="customCommissionerChanged()"
						[testHook]="testHooks.CommissionerEmail"
					></app-input>
					<app-input
						label="Phone Number"
						[formControl]="commissionerPhoneNumber"
						(debounce)="customCommissionerChanged()"
						[testHook]="testHooks.CommissionerPhoneNumber"
					></app-input>
				</div>
			</div>
		</div>
		<div class="flex flex-1 flex-col gap-4 mt-6">
			<h4 class="text-lg m-0">Witness</h4>
			<ui-button-segmented
				[options]="witnessRadioGroupItems"
				[selectedId]="witnessSelectionType.value"
				(selectedIdChange)="setOfficialsSelectionType('witness', $event)"
				[fullWidth]="true"
				variant="text-only"
				intercomAttr="witnessTypeOptions"
				[testHook]="testHooks.ButtonSegmented1"
			></ui-button-segmented>

			<div *ngIf="witnessSelectionType.value === WITNESS_SELECTION_TYPE.OTHER">
				<app-business-user-dropdown
					label="Other Lawyer/Clerk"
					[userId]="witnessUserId?.value"
					(selected)="setWitnessUser($event)"
				></app-business-user-dropdown>

				<div class="flex gap-4 items-center my-6">
					<span class="flex flex-1 border-t border-grey-light"></span>
					<span class="text-sm text-grey-light">Or Set Custom Witness</span>
					<span class="flex flex-1 border-t border-grey-light"></span>
				</div>
				<div class="flex flex-col gap-4">
					<app-input
						label="Name"
						[formControl]="witnessName"
						(debounce)="customWitnessChanged()"
						[testHook]="testHooks.WitnessName"
					></app-input>
					<app-input
						label="Email"
						[formControl]="witnessEmail"
						(debounce)="customWitnessChanged()"
						[testHook]="testHooks.WitnessEmail"
					></app-input>
					<app-input
						label="Phone Number"
						[formControl]="witnessPhoneNumber"
						(debounce)="customWitnessChanged()"
						[testHook]="testHooks.WitnessPhoneNumber"
					></app-input>
				</div>
			</div>
		</div>
	</div>

	<div class="p-6 border-t border-gray-200">
		<ui-button
			preset="HIGH_EMPHASIS"
			label="Save"
			[disabled]="(createStatus$ | async) === CreateStatusType.creating"
			[loading]="(createStatus$ | async) === CreateStatusType.creating"
			type="submit"
			[testHook]="testHooks.SaveButton"
		></ui-button>
	</div>

	<div *ngIf="submitted && appointmentDate && !appointmentTime" [@openClose]>
		<app-message-bar
			>Please provide the time of the appointment</app-message-bar
		>
	</div>

	<div *ngIf="(createStatus$ | async) === CreateStatusType.failed" [@openClose]>
		<app-message-bar type="error"
			>Unable to save key dates. Please try again.</app-message-bar
		>
	</div>
</form>
